import React from 'react'
import { getAttributeCourseStaticInfo } from "./enrolment"
import { helpLink, helpVuCourseLink } from "./links"
import parse from 'html-react-parser';

export const renderParagraph = (text, key) => {
    return <p key={key}>{parse(text)}</p>
}

export const renderError = (error, key) => {
    return renderParagraph(error.apiErrorMessage, key)
}

export const renderCourseStructure = (endText, key) => {
    return React.createElement('p', { key: key }, 'Refer to your ', helpVuCourseLink(getAttributeCourseStaticInfo('courseCode'), 'course structure'), ' ', endText)
}

export const renderCUA = key => {
    return React.createElement('p', {}, 'Contact your ', helpLink(), ' if you require assistance.')
}

export const renderPreRequisiteMessage = key => {
    return React.createElement(
        'p',
        { key: key },
        'Please remove any units that do not meet the pre-requisite requirement to continue with your enrolment. Check your ',
        helpVuCourseLink(getAttributeCourseStaticInfo('courseCode'), 'course structure'),
        ' for details or contact your ',
        helpLink(),
        ' for assistance.'
    )
}

export const processUnitAddErrors = (enrolmentErrors = [], partialSuccess = false, genericErrorCode) => {
    let returnResults = []
  
    let containsPrereqError = false
  
    if (enrolmentErrors && enrolmentErrors.length < 0) {
      return null
    }
  
    let allUnitCodes = ''
  
    enrolmentErrors
      .filter(error => error.apiErrorCode !== genericErrorCode)
      .map((error, index) => {
        if (!containsPrereqError && error.apiErrorCode && error.apiErrorCode.includes('pre_requisites')) {
          containsPrereqError = true
          returnResults.push(renderError(error, `non_generic_error_${index}`))
        }
  
        if (index !== 0) {
          allUnitCodes += ', '
        }
        allUnitCodes += error.unitCode
      })
  
    if (containsPrereqError) {
      returnResults.push(renderPreRequisiteMessage(`prereq_1`))
    } else {
      let genericCodeError = enrolmentErrors.find(error => {
        return error.apiErrorCode === genericErrorCode
      })
  
      if (genericCodeError) {
        returnResults.push(renderError(genericCodeError, `generic_error_0`))
      }
  
      if (partialSuccess) {
        returnResults.push(React.createElement('p', {}, 'Failed enrolments in ', allUnitCodes, '. Please try again or contact VUHQ for assistance.'))
      }
    }
  
    return returnResults
  }